import React from 'react'
import Sitemap from './sitemap'
import SocialButtons from '../social/social-buttons'
import logo from '../../styles/images/logo-secondary.svg'
import { Link } from 'react-router-dom'

const Footer = props => {
  return (
    <footer className='main-footer'>
      <div className='footer-logo'>
        <Link to='/explore'>
          <img src={logo} alt='Chairbids Logo' />
        </Link>
      </div>
      <Sitemap
        listItems={[
          {
            title: 'About us',
            url: '/about-us'
          },
          {
            title: 'Terms of service',
            url: '/terms'
          },
          {
            title: 'Contact',
            url: '/contact'
          },
          {
            title: 'Privacy Policy',
            url: '/privacy-policy'
          },
          {
            title: 'Help',
            url: '/help'
          }
        ]}
      />
      <SocialButtons
        light
        icons={[
          'social-facebook',
          'social-twitter',
          'social-instagram',
          'social-google'
        ]}
      />
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/ui/footer/footer.js